import React from "react";
import { useDesignFormStore } from "../../store/DesignMasterStore";

const BasicInfoTab: React.FC = () => {
  const { basicInfo, updateBasicInfo } = useDesignFormStore();

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    updateBasicInfo(name as keyof typeof basicInfo, value);
  };

  // console.log(basicInfo,"basicInfo");

  return (
    <>
      <div>
        <div className="font-semibold text-2xl mb-5">
          Basic Design Information
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Design No. */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Design No.
            </label>
            <input
              type="text"
              name="designNo"
              value={basicInfo.designNo}
              onChange={handleChange}
              placeholder="Auto-generated or manual input"
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
            />
          </div>
          {/* Client Name */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Client Name
            </label>
            <input
              type="text"
              name="clientName"
              value={basicInfo.clientName}
              onChange={handleChange}
              placeholder="Enter client name"
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
            />
          </div>
          {/* Color Specification */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Color Specification
            </label>
            <input
              type="text"
              name="colorSpecification"
              value={basicInfo.colorSpecification}
              onChange={handleChange}
              placeholder="e.g., Navy Blue, #1a365d"
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
            />
          </div>
          {/* Design Category */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Design Category
            </label>
            <select
              name="designCategory"
              value={basicInfo.designCategory}
              onChange={handleChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
            >
              {" "}
              <option value="all">Select category</option>
              <option value="kaftaan">Kaftaan</option>
              <option value="co-ord-set">Co-ord set</option>
              <option value="plazo">Plazo style</option>
              <option value="farshi">Farshi style</option>
              <option value="kurti">Kurti style</option>
              <option value="pant">Pant style</option>
              <option value="gharara">Gharara</option>
              <option value="patiyala">Patiyala</option>
              <option value="jacket">Jacket style</option>
              <option value="choli">Choli style</option>
              <option value="print">Print</option>
              <option value="other">Others</option>
            </select>
          </div>
          {/* Status */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Status
            </label>
            <select
              name="status"
              value={basicInfo.status}
              onChange={handleChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
            >
              <option value="Active">Active</option>
              <option value="Inactive">Inactive</option>
            </select>
          </div>
        </div>
      </div>
    </>
  );
};

export default BasicInfoTab;
